
import React from 'react';
import { regex } from '../../../../manage/common/constant';
export const basicDetail = [
  { colKey: 'schoolId', label: 'School ID', colType: 'input', disabled: true },
  { colKey: 'name', label: 'Name', colType: 'input', disabled: false, regex: regex?.alphaNumericWithSpaceAndUnderscore },
  { colKey: 'status', label: 'Status', colType: 'select', disabled: false, },
  { colKey: 'shortDescription', label: 'Short desc', colType: 'input', disabled: false, maxLength:20 },
  { colKey: 'longDescription', label: 'Long desc', colType: 'input', disabled: false },
  { colKey: 'board', label: 'Board', colType: 'select', disabled: false },
  { colKey: 'type', label: 'Type', colType: 'select', disabled: false },
  { colKey: 'medium', label: 'Medium', colType: 'select', disabled: false },
  { colKey: 'effectiveDate', label: 'Effective Date', colType: 'date', disabled: false },
  { colKey: 'pincode', label: 'Pin Code', colType: 'input', disabled: false, maxLength:6 },
  { colKey: 'country', label: 'Country', colType: 'select', disabled: true },
  { colKey: 'state', label: 'State', colType: 'select', disabled: true },
  { colKey: 'city', label: 'City', colType: 'select', disabled: true },
  { colKey: 'address', label: 'Address', colType: 'input', disabled: false,maxLength:255 },
]
export const initialBasicDetail = {
  //schoolId:'63263',
  name: '',
  status: { label: 'ACTIVE', value: 'ACTIVE' },
  shortDescription: '',
  longDescription: '',
  board: {},
  type: '',
  medium: '',
  effectiveDate: '',
  pincode: '',
  country: '',
  state: '',
  city: '',
  address: ''
}
export const inputStyle = {
  // width:'90%',
  height: '40px',
  borderRadius: '5px'

}

export const newRow = {
  name: "",
  jobTitle: "",
  academicCareer: "",
  contact: "",
  type: "",
  department: "",
  email: "",
};
export const newBuMappingRow = {
  bu: "",
  branch: "",
  type: "",
  address: "",
  pincode: "",

};
export const schoolTypeDropdown = [
  { label: 'GOVT - Government', value: 'GOVT' },
  { label: 'PRIV - Private', value: 'PRIV' },
  { label: 'PUBL - Public', value: 'PUBL' },
  { label: 'STBD - State Board', value: 'STBD' },
  { label: 'DEFN - Military/Defense', value: 'DEFN' }
]

export const jobTitleDropdown = [
  { label: 'Principal', value: 'Principal' },
  { label: 'Admin', value: 'Admin' },
  { label: 'Coordinator', value: 'Coordinator' },
  { label: 'HOD', value: 'HOD' },
]

export const jobTypeDropdown = [
  { label: 'Academic', value: 'Academic' },
  { label: 'Non Academic', value: 'Non Academic' },
]

export const departmentDropdown = [
  { label: 'Admin', value: 'Admin' },
  { label: 'Teacher', value: 'Teacher' },
]

export const branchTypeDropdown = [
  { label: 'Owned Branch', value: 'Owned Branch' },
  { label: 'Franchise', value: 'Franchise' },
  { label: 'ALC Center', value: 'ALC Center' },
]
export const Glob = [
  { id: 1, name: 'ddddd', jobTitle: 'djdjdj', contact: '373838' },
  { id: 2, name: 'ddddd', jobTitle: 'djdjdj', contact: '373838' }
]

export const checkValidation = (basicRowForm = {}, activeContactRows = [], branchMappingRows = []) => {
  const p = (Object.values({ ...initialBasicDetail, ...basicRowForm }).every(value => value != null && value !== undefined && value != '')
    && branchMappingRows.length != 0);
  return p;
}
export const getDropdownValueById = (dropdown = [], id) => {
  if(Array.isArray(id)){
   return id.map(el=>(dropdown.find(item => ( String(item?.value).toUpperCase() === String(el).toUpperCase()||
   String(item?.label).toUpperCase() === String(el).toUpperCase() ||
   String(item?.customId) === String(el)
  ))))
  }
  else{
  return dropdown.find(item => ( String(item?.value).toUpperCase() === String(id).toUpperCase()||
   String(item?.label).toUpperCase() === String(id).toUpperCase() ||
   String(item?.customId) === String(id)
  ))
  }
}

export const getDisplayList = (dropdown = [], rows = []) => {
  const board = getDropdownValueById(dropdown?.board, rows?.board)
  const country = getDropdownValueById(dropdown?.country, rows?.country);
  const state = getDropdownValueById(dropdown?.state, rows?.state);
  const city = getDropdownValueById(dropdown?.city, rows?.city);
  const medium = getDropdownValueById(dropdown?.medium, rows?.medium)
  const status = getDropdownValueById(dropdown?.status, rows?.status);
  const type = getDropdownValueById(dropdown?.type, rows?.type);
  return {
    basicDetail: {
      ...rows, board, country, state, city, medium, status, type, contacts: [], branches: [], schoolId:rows?.id
    },
    activeContact: rows?.contacts && rows?.contacts.map((item, index) => (
      {
        ...item,
        seqId: index + 1,
        jobTitle: getDropdownValueById(dropdown?.jobTitle, item?.jobTitle),
        type: getDropdownValueById(dropdown?.jobType, item?.type),
        department: getDropdownValueById(dropdown?.department, item?.department),
      }
    )),
    branchMapping: rows?.branches && rows?.branches.map(item => (
      {
        ...item,
        bu: getDropdownValueById(dropdown?.businessArea, item?.bu),
        branch: { label: item?.branch, value: item?.branch },
        type: getDropdownValueById(dropdown?.branchType, item?.type),
      }
    ))

  }
}
export const initialGlobRows = {
  "name": "MG International School for womens",
  "status": "ACTIVE",
  "shortDescription": "A premier institution for quality education.",
  "longDescription": "ABC International School offers a comprehensive curriculum that emphasizes academic excellence, character building, and extra-curricular development.",
  "board": 2,
  "type": "Co-Educational",
  "medium": "English",
  "effectiveDate": "2025-03-26T00:00:00Z",
  "country": 1,
  "region": 3,
  "state": 5,
  "city": 3,
  "address": "123 Main Street, Downtown",
  "pincode": "110005",
  "contacts": [
    {
      "name": "Shresth Mishra",
      "jobTitle": "Principal",
      "contact": "9870543210",
      "type": "Primary",
      "department": "Administration",
      "email": "john.doe@example.com"
    }
  ],
  "branches": [
    {
      "bu": 201,
      "branch": "West Campus",
      "type": "Secondary",
      "address": "456 North Road",
      "pincode": "654321"
    }
  ]
}

export const statusMapping = {
  FAILURE: 'Resubmit',
  SUCCESS: 'Approved',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive'
}

export const statusStyle = {
  Resubmit: {
    backgroundColor: "#F9D9D7",
    color: "#B32306",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Approved: {
    backgroundColor: "#BBE2CE",
    color: "#0B442D",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },

};

export const getUniqueDropdown=(dropdown,tempDropdown,key)=>{
const tempArr = tempDropdown.map(obj => obj?.[key]?.label);
return dropdown.filter(obj => !tempArr.includes(obj.label));
}

export const checkDuplicateEntry=(list,obj,key)=>{
     return   list?.some((e)=>(e?.[key]==obj?.[key]))
}